var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 4.37975L12.7 2.1519C12.3 1.94937 11.8 1.94937 11.3 2.1519L5.3 4.37975C4.5 4.68354 4 5.49367 4 6.3038V11.0633C4 16.0253 7.3 20.7848 11.7 22C11.9 22 12.1 22 12.3 22C16.7 20.7848 20 16.0253 20 11.0633V6.3038C20 5.49367 19.5 4.68354 18.7 4.37975ZM14.8 14.8101C14.4 15.2152 13.8 15.2152 13.4 14.8101L12 13.3924L10.6 14.8101C10.2 15.2152 9.6 15.2152 9.2 14.8101C8.8 14.4051 8.8 13.7975 9.2 13.3924L10.6 11.9747L9.2 10.557C8.8 10.1519 8.8 9.5443 9.2 9.13924C9.6 8.73418 10.2 8.73418 10.6 9.13924L12 10.557L13.4 9.13924C13.8 8.73418 14.4 8.73418 14.8 9.13924C15.2 9.5443 15.2 10.1519 14.8 10.557L13.4 11.9747L14.8 13.3924C15.2 13.7975 15.2 14.4051 14.8 14.8101Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.6167f1a1.svg";
export { ForwardRef as ReactComponent };